module.exports = __webpack_public_path__ + "static/S-Factor_VicePresident_Sales-NA-a487a7efba8021843d7db393e238743d.pdf";